import { useState } from 'react'
import { useToasts } from 'react-toast-notifications'
import billingApi from 'services/api/billing'

export const useInvoiceActions = () => {
  const [isSendingInvoice, setIsSendingInvoice] = useState(false)
  const { addToast } = useToasts()

  const handleSendInvoice = contactData => {
    setIsSendingInvoice(true)

    billingApi
      .sendInvoice(contactData)
      .then(res => {
        addToast(` ${res.deliverySummary}`, {
          appearance: 'success'
        })
      })
      .catch(err => {
        addToast(err.message, { appearance: 'error' })
      })
      .finally(() => {
        setIsSendingInvoice(false)
      })
  }

  return { isSendingInvoice, handleSendInvoice }
}
